var ScriptLoader = require('helpers/script-loader.js');
var ThirdPartyService = require('third-party/third-party-service.js');

/**
 * Inspectet
 */
(function(root, doc, undefined) {

    'use strict';

    var isVendorDisabled = function() {
        return ThirdPartyService.isVendorDisabled();
    };

    var init = function() {

        if (isVendorDisabled()) {
            return false;
        }

        // Init Inspectlet variables
        root.__insp = root.__insp || [];
        root.__insp.push(['wid', 2112032064]);
        root.__inspld = 1;

        // Inject it! (delayed after load event)
        ScriptLoader.add('//cdn.inspectlet.com/inspectlet.js', 'inspsync');

    };

    init();

})(window, document);
